import { PageSizeButton } from '@/features/product/components/atoms/PageSizeButton';
import React from 'react';

export interface PageSizeOption {
  label: string;
  value: string | number;
}

interface PageSizeSelectorProps {
  options: PageSizeOption[];
  selectedValue?: string | number;
  onChange: (value: string | number) => void;
  label?: string;
  className?: string;
}

export const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  options,
  selectedValue,
  onChange,
  label = '목록',
  className,
}) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        {label && <span className="body-14m text-[#323B49]">{label}</span>}
        <div className="flex items-center gap-0">
          {options.map((option) => (
            <PageSizeButton
              rounded={option.value === options[0].value ? 'left' : 'right'}
              key={option.value}
              value={option.label}
              isSelected={selectedValue === option.value}
              onClick={() => onChange(option.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
